import React, { useEffect, useState } from 'react';
import s from './DraggableZoomable.scss';

const DraggableZoomable = ({ isWapView, children, hideZoomBtn }) => {
  const [scale, setScale] = useState(1);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [dragging, setDragging] = useState(false);
  const [startDrag, setStartDrag] = useState({ x: 0, y: 0 });
  const [initialPosition, setInitialPosition] = useState(null);

  useEffect(
    () => {
      if (dragging) {
        document
          .getElementsByTagName('body')[0]
          .classList.add('disable-scroll');
      } else {
        document
          .getElementsByTagName('body')[0]
          .classList.remove('disable-scroll');
      }
    },
    [dragging],
  );

  const handleDragStart = e => {
    e.preventDefault();
    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    const clientY = e.touches ? e.touches[0].clientY : e.clientY;
    setInitialPosition({ x: clientX, y: clientY });
    setStartDrag({ x: clientX - position.x, y: clientY - position.y });
  };

  const handleDragMove = e => {
    if (hideZoomBtn) return;
    if (!initialPosition) return; // Do nothing if no initial position set
    e.preventDefault();

    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    const clientY = e.touches ? e.touches[0].clientY : e.clientY;

    // Set a threshold for detecting dragging
    const threshold = 5;
    const movedX = Math.abs(clientX - initialPosition.x);
    const movedY = Math.abs(clientY - initialPosition.y);

    if (movedX > threshold || movedY > threshold) {
      setDragging(true);
    }

    if (dragging) {
      const newX = clientX - startDrag.x;
      const newY = clientY - startDrag.y;
      setPosition({ x: newX, y: newY });
    }
  };

  const handleDragEnd = () => {
    setDragging(false);
    setInitialPosition(null); // Reset initial position after drag ends
  };

  const zoomIn = () => setScale(prev => prev + 0.1);
  const zoomOut = () => setScale(prev => Math.max(0.1, prev - 0.1));
  const reset = () => {
    setScale(1);
    setPosition({ x: 0, y: 0 });
  };
  const dragCursor = dragging ? 'grabbing' : 'grab';

  return (
    <div
      className={s.zoomable}
      {...!isWapView && {
        onMouseMove: handleDragMove,
        onMouseUp: handleDragEnd,
        onMouseLeave: handleDragEnd,
        onTouchMove: handleDragMove,
        onTouchEnd: handleDragEnd,
      }}
    >
      <div
        {...!isWapView && {
          onMouseDown: handleDragStart,
          onTouchStart: handleDragStart,
        }}
        style={
          !isWapView
            ? {
                transform: `translate(${position.x}px, ${
                  position.y
                }px) scale(${scale})`,
                transformOrigin: 'center',
                display: 'inline-block',
                cursor: hideZoomBtn ? 'default' : dragCursor,
                transition: dragging ? 'none' : 'transform 0.2s ease',
                pointerEvents: dragging ? 'none' : 'auto',
              }
            : {
                transform: `translate(${position.x}px, ${
                  position.y
                }px) scale(${scale})`,
                transformOrigin: 'top left',
                display: 'inline-block',
                cursor: hideZoomBtn ? 'default' : dragCursor,
                transition: dragging ? 'none' : 'transform 0.2s ease',
                pointerEvents: dragging ? 'none' : 'auto',
              }
        }
      >
        {children}
      </div>

      {!hideZoomBtn && (
        <div className={s.zoomBtnWrap}>
          <button className={s.zoomIn} onClick={zoomIn} />
          <button className={s.zoomOut} onClick={zoomOut} />
          <button className={s.reset} onClick={reset} />
        </div>
      )}
    </div>
  );
};

export default DraggableZoomable;
